import { eq, flow, get } from 'lodash/fp';
import { filter, tap, map } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { ACTIONS } from 'redux-api-call';
import { updateAdminUserAC } from '../../apiCalls/adminUsers/get';
import { ACTIVATE_USER_API_ID } from '../../apiCalls/adminUsers/activate';

const handleActivateSuccess = (actions$, store$) =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(
      flow(
        get('payload.name'),
        eq(ACTIVATE_USER_API_ID)
      )
    ),
    tap(action => {
      console.log(action);
    }),
    map(action => {
      const user = get('payload.json.user')(action);
      return updateAdminUserAC(user, store$.value);
    })
  );

export default combineEpics(handleActivateSuccess);
